<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4 v-html="title"></h4>
        <div v-if="subtitle" class="subtitle">{{subtitle}}</div>
        <form v-on:submit.prevent="close(true, field)">
          <div :class="{fieldGroup: true, hasError: hasError}">
            <input class="field" :placeholder="placeholder"
              :type="fieldType" v-model="field" ref="field">
            <div class="fieldError" v-if="hasError">Wrong password.</div>
          </div>
          <div class="modalAction">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!loading">Cancel</button>
            <button class="btn btnPrimary" type="submit" v-if="!loading">
              <span v-if="action">{{action}}</span>
              <span v-else>Insert</span>
            </button>
            <button class="btn btnPrimary loading" type="button" v-else>
              <span>Loading...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      loading: false,
      hasError: false,
      field: '',
      title: '',
      subtitle: null,
      placeholder: '',
      fieldType: 'text',
      action: '',
      next: null,
    };
  },
  methods: {
    open(d, n) {
      this.title = d.title;
      this.subtitle = d.subtitle;
      this.placeholder = d.placeholder;
      this.action = d.action;
      this.field = d.value;
      this.fieldType = (d.type) ? d.type : 'text';
      this.loading = false;
      this.hasError = false;
      this.next = n;
      this.show = true;
    },
    close(b, d) {
      if (b && this.fieldType === 'password') {
        this.loading = true;
        this.$http.post(this.$config.uri('user/pwd/validate'), {
          pwd: this.field,
        }).then((response) => {
          this.loading = false;
          if (response.data.status !== 200) {
            this.$refs.field.focus();
            this.hasError = true;
            return;
          }
          this.show = false;
          if (this.next && typeof this.next === 'function') {
            this.next(b, d);
          }
        });
        return;
      }
      this.show = false;
      if (this.next && typeof this.next === 'function') {
        this.next(b, d);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: .7;
      z-index: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      max-width: none;
      width: 460px;
      box-sizing: border-box;
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      .subtitle{
        color: #767676;
        margin: -11px 0 20px;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
          &.loading{
            background-color: #ccc;
            color: #999;
            cursor: default;
            box-shadow: none !important;
          }
        }
      }
    }
  }
</style>
